/**
 * @generated SignedSource<<80c76e1eb182f385638653fad45bcd83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useMaintenanceLogsRelayByIdQuery$variables = {
  id: string;
};
export type useMaintenanceLogsRelayByIdQuery$data = {
  readonly getMaintenanceLog: {
    readonly adminUser: {
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null | undefined;
    readonly adminUserId: string;
    readonly createdOn: any;
    readonly hardware: {
      readonly hardwareProduct: {
        readonly id: string;
        readonly primaryIdentifier: string | null | undefined;
      } | null | undefined;
      readonly hardwareType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly number: number | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly hardwareOldId: string | null | undefined;
    readonly id: string;
    readonly location: {
      readonly id: string;
      readonly name: string;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly locationId: string | null | undefined;
    readonly maintenanceTask: {
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly maintenanceTaskOldId: string;
    readonly maintenanceTicket: {
      readonly id: string;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly maintenanceTicketOldId: string | null | undefined;
    readonly notes: string | null | undefined;
    readonly oldId: string | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly system: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string;
    readonly timeTracking: number;
  } | null | undefined;
};
export type useMaintenanceLogsRelayByIdQuery = {
  response: useMaintenanceLogsRelayByIdQuery$data;
  variables: useMaintenanceLogsRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MaintenanceLog",
    "kind": "LinkedField",
    "name": "getMaintenanceLog",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "adminUserId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hardwareOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maintenanceTaskOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maintenanceTicketOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "notes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeTracking",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUser",
        "kind": "LinkedField",
        "name": "adminUser",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Hardware",
        "kind": "LinkedField",
        "name": "hardware",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareType",
            "kind": "LinkedField",
            "name": "hardwareType",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareProduct",
            "kind": "LinkedField",
            "name": "hardwareProduct",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryIdentifier",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Location",
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaintenanceTask",
        "kind": "LinkedField",
        "name": "maintenanceTask",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaintenanceTicket",
        "kind": "LinkedField",
        "name": "maintenanceTicket",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "system",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMaintenanceLogsRelayByIdQuery",
    "selections": (v5/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMaintenanceLogsRelayByIdQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "8e347119d66cc2a1d25e4e75693863a5",
    "id": null,
    "metadata": {},
    "name": "useMaintenanceLogsRelayByIdQuery",
    "operationKind": "query",
    "text": "query useMaintenanceLogsRelayByIdQuery(\n  $id: ID!\n) {\n  getMaintenanceLog(id: $id) {\n    id\n    oldId\n    adminUserId\n    createdOn\n    hardwareOldId\n    locationId\n    maintenanceTaskOldId\n    maintenanceTicketOldId\n    notes\n    organizationId\n    systemId\n    systemOldId\n    timeTracking\n    adminUser {\n      id\n      email\n      firstName\n      lastName\n    }\n    hardware {\n      id\n      oldId\n      number\n      hardwareType {\n        id\n        name\n      }\n      hardwareProduct {\n        id\n        primaryIdentifier\n      }\n    }\n    location {\n      id\n      oldId\n      name\n    }\n    maintenanceTask {\n      id\n      oldId\n      name\n      description\n    }\n    maintenanceTicket {\n      id\n      oldId\n    }\n    system {\n      id\n      oldId\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36d0ae0522275d577cb5dcaa0bd038d3";

export default node;
